export const LocationIcon = ({ className, ...props }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M10.2504 1.60693C12.0975 1.60693 13.8689 2.34067 15.1749 3.64673C16.481 4.95278 17.2147 6.72418 17.2147 8.57122C17.2147 11.5141 15.1468 14.7212 11.0647 18.2269C10.8377 18.4219 10.5483 18.529 10.2491 18.5288C9.94985 18.5285 9.66063 18.4209 9.43399 18.2255L9.16399 17.9912C5.26256 14.5769 3.28613 11.4484 3.28613 8.57122C3.28613 6.72418 4.01987 4.95278 5.32593 3.64673C6.63198 2.34067 8.40338 1.60693 10.2504 1.60693ZM10.2504 5.89265C9.54002 5.89265 8.85871 6.17485 8.35638 6.67718C7.85405 7.17951 7.57185 7.86082 7.57185 8.57122C7.57185 9.28162 7.85405 9.96293 8.35638 10.4653C8.85871 10.9676 9.54002 11.2498 10.2504 11.2498C10.9608 11.2498 11.6421 10.9676 12.1445 10.4653C12.6468 9.96293 12.929 9.28162 12.929 8.57122C12.929 7.86082 12.6468 7.17951 12.1445 6.67718C11.6421 6.17485 10.9608 5.89265 10.2504 5.89265Z"
        fill="currentColor"
      />
    </svg>
  );
};
